import { stateGo } from 'redux-ui-router';
import { anchorStorage } from 'utils';
import { selectMember } from 'logic/member';
import { fetchWorkoutCollection, selectWorkoutCollection } from 'logic/workout';
import {
  selectFavouriteWorkoutIds,
  mapIsFavouriteWorkouts,
} from 'logic/favourite';

export const workoutsHack = {
  template: `
    <div class="pb-3">
      <collection-header
        collection="$ctrl.collection"
        is-loading="$ctrl.isLoading">
      </collection-header>
      <div class="container pb-3">
        <div class="row mb-4">
          <div class="col-md-6 pt-3"
            ng-repeat="item in $ctrl.collection.workouts track by $index">
            <card-workout
              description="item.collectionDescriptionHtml"
              member="$ctrl.member"
              type="horizontal"
              workout="item"
              on-click="$ctrl.onClick($ctrl.hackId, item)">
            </card-workout>
          </div>
        </div>
      </div>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Wait for parent hacks collection to finish loading before fetching
        this.interval = setInterval(() => {
          if (!this.isLoading) {
            clearInterval(this.interval);

            if (!this.collection || !this.collection.workouts.length) {
              this.fetchWorkoutCollection(this.hackId);
            }
          }
        }, 500);
      },

      $onDestroy() {
        this.disconnect();

        if (this.interval) {
          clearInterval(this.interval);
        }
      },

      onClick(hackId, { id, exercisePlanId, name }) {
        this.stateGo('workouts.hacks.exercise', {
          hackId,
          id,
          exercisePlanId,
        });

        anchorStorage.set($ngRedux.getState(), name);
      },

      mapState({ favourite, member, workout, router }) {
        const { hackId } = router.currentParams;

        return {
          hackId,
          isLoading: workout.isLoading,
          member: selectMember(member),
          collection: mapIsFavouriteWorkouts(
            selectWorkoutCollection(workout, hackId),
            selectFavouriteWorkoutIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          fetchWorkoutCollection,
          stateGo,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Hack.js